import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isNullOrUndefined, isDefined} from '../../../../../commons/utils';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-filter-checkbox',
  imports: [IonicModule, TranslateModule],
  templateUrl: './filter-checkbox.component.html',
  styleUrls: ['./filter-checkbox.component.css']
})
export class FilterCheckboxComponent {
  readonly isNullOrUndefined = isNullOrUndefined;
  readonly isDefined = isDefined;

  @Input() checked = false;
  @Input() disabled = false;
  @Input() label: string;
  @Input() translateString;
  @Output() readonly change = new EventEmitter<boolean>();

  toggleCheckbox(): void {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.change.emit(this.checked);
    }
  }
}
